module.exports = __webpack_public_path__ + "img/20191126161740301.24fa4038.jpg";